import { render, staticRenderFns } from "./CommonLeadConversations.vue?vue&type=template&id=38ea1caf&scoped=true&"
import script from "./CommonLeadConversations.vue?vue&type=script&lang=js&"
export * from "./CommonLeadConversations.vue?vue&type=script&lang=js&"
import style0 from "./CommonLeadConversations.vue?vue&type=style&index=0&id=38ea1caf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ea1caf",
  null
  
)

export default component.exports